import React from 'react'
import { Text, StyleSheet, View } from 'react-native'
import { IconErrorHint } from '../../../app/src/assets/icons'
import { composeStyle } from '../helpers'
import { Trans, useTranslation } from 'react-i18next'

enum ErrorColor {
  CORRECT = '#00A0F3',
  WRONG = '#EC002A',
}

const ErrorTextComponent: React.FC<{ text?: string; containerStyle?: any }> = ({
  text,
  containerStyle,
}) => {
  if (!text) return null
  return (
    <View
      style={composeStyle(styles.container, { marginTop: 4 }, containerStyle)}
    >
      <View style={styles.iconContainer}>
        <IconErrorHint width={13} height={13} />
      </View>

      <Text style={styles.errorText}>{text}</Text>
    </View>
  )
}

export const PasswordErrorText: React.FC<{
  passwordValidation: any
  containerStyle?: any
}> = ({ containerStyle, passwordValidation }) => {
  const { t } = useTranslation('global')
  const getErrorColor = (isValid: boolean) =>
    isValid ? ErrorColor.CORRECT : ErrorColor.WRONG

  return (
    <View style={composeStyle(styles.container, containerStyle)}>
      <View style={styles.iconContainer}>
        <IconErrorHint width={13} height={13} />
      </View>

      <Text style={styles.errorText}>
        <Trans
          i18nKey="integrations.pay-as-guest.enter-password.password-hint"
          t={t}
          components={{
            chrs: (
              <Text
                key="length"
                style={{
                  color: getErrorColor(passwordValidation.length),
                }}
              />
            ),
            uprcs: (
              <Text
                key="uppercase"
                style={{ color: getErrorColor(passwordValidation.uppercase) }}
              />
            ),
            nmbr: (
              <Text
                key="number"
                style={{ color: getErrorColor(passwordValidation.number) }}
              />
            ),
          }}
        />
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconContainer: {
    marginBottom: 2,
  },
  errorText: {
    fontSize: 12,
    lineHeight: 14.4,
    color: '#EC002A',
    fontFamily: 'Inter',
    fontWeight: '400',
    marginLeft: 3,
  },
})

export default ErrorTextComponent
